import { render, staticRenderFns } from "./CreateProrram.vue?vue&type=template&id=590e3390&scoped=true"
import script from "./CreateProrram.vue?vue&type=script&lang=js"
export * from "./CreateProrram.vue?vue&type=script&lang=js"
import style0 from "./CreateProrram.vue?vue&type=style&index=0&id=590e3390&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e3390",
  null
  
)

export default component.exports